import { Routes as BrowserRoutes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "../layouts/DashboardLayout";
import AuthLayout from "../layouts/AuthLayout";
import Dashboard from "../pages/Dashboard/Dashboard";
import Email from "../pages/Dashboard/Email";
import YahooSignIn from "../pages/Dashboard/Yahoo";
import OutlookSignIn from "../pages/Dashboard/Outlook";
import GmailLoginPage from "../pages/Dashboard/Gmail";
import NormsPage from "../pages/Dashboard/NormsPage";
import Microsoft from "../pages/Dashboard/Microsoft";
const AppRoutes = () => {
  return (
    <BrowserRoutes>
      <Route element={<DashboardLayout />}>
        <Route path="/dashboard" element={<Dashboard />} />

        <Route path="/email" element={<Email />} />
      </Route>
      <Route path="/" element={<NormsPage />} />
      <Route path="/yahoo" element={<YahooSignIn />} />
      <Route path="/outlook" element={<OutlookSignIn />} />
      <Route path="/gmail" element={<GmailLoginPage />} />
      <Route path="/microsoft365" element={<Microsoft />} />
      <Route path="/microsoftexchange" element={<Microsoft />} />
      <Route element={<AuthLayout />}></Route>
    </BrowserRoutes>
  );
};

export default AppRoutes;
